import { FormEvent, useState } from 'react';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/dahgoorp14a1h3mr6mag';

type Status = 'idle' | 'loading' | 'success' | 'error';

export default function NewsletterForm() {
  const [status, setStatus] = useState<Status>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const payload = new FormData(form);

    const honey = String(payload.get('website_alt') || '').trim();
    if (honey) {
      setStatus('success');
      setMessage('订阅成功，下一期精选会第一时间发送到你的邮箱。');
      form.reset();
      return;
    }
    payload.delete('website_alt');

    const body = new URLSearchParams();
    payload.forEach((value, key) => {
      if (typeof value === 'string' && value.trim() !== '') body.append(key, value);
    });

    setStatus('loading');
    setMessage('');

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null =
        null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const ok = response.ok && parsed?.code === 'OK';

      if (ok) {
        setStatus('success');
        setMessage('订阅成功，下一期精选会第一时间发送到你的邮箱。');
        form.reset();
      } else {
        setStatus('error');
        setMessage(String(serverMsg || '提交失败，请稍后重试。'));
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请稍后重试。');
    }
  };

  return (
    <form id="newsletter-subscribe-form" onSubmit={handleSubmit} data-readdy-form className="w-full">
      <div className="flex flex-col gap-2 sm:flex-row">
        <input
          type="email"
          name="email"
          required
          placeholder="输入邮箱，接收每周精选"
          aria-label="订阅邮箱"
          className="h-10 flex-1 rounded-md border border-primary-700/60 bg-primary-950/60 px-3 text-sm text-background-50 outline-none transition-colors placeholder:text-background-300/70 focus:border-accent-400"
        />
        <button
          type="submit"
          disabled={status === 'loading'}
          className="flex h-10 cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400 disabled:cursor-not-allowed disabled:opacity-70"
        >
          <i className="ri-send-plane-fill text-base" aria-hidden="true"></i>
          {status === 'loading' ? '提交中' : '立即订阅'}
        </button>
      </div>

      <input
        type="text"
        name="website_alt"
        className="form-field-alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      {message && (
        <p
          className={`mt-2 text-xs ${
            status === 'success' ? 'text-accent-300' : 'text-primary-200'
          }`}
        >
          {message}
        </p>
      )}
    </form>
  );
}